import {
  useV2CreateContactForClientMutation,
  useV2UpdateClientContactMutation,
  useV2DeleteClientContactMutation,
} from "@generated";
import type { V2ContactResource } from "@generated";
import type { ContactFormValues } from "../types";

// `contactable` is inferred from the URL clientId server-side, so we build the
// resource and cast (the generated type marks relationships required).
export const buildContactData = (
  values: ContactFormValues,
  id?: string
): V2ContactResource =>
  ({
    type: "contacts",
    ...(id ? { id } : {}),
    attributes: {
      name: values.name,
      title: values.title || undefined,
      email: values.email || undefined,
      phone: values.phone || undefined,
    },
  } as unknown as V2ContactResource);

export const useContactMutations = (clientId: string) => {
  const [create] = useV2CreateContactForClientMutation();
  const [update] = useV2UpdateClientContactMutation();
  const [destroy] = useV2DeleteClientContactMutation();

  return {
    create: (values: ContactFormValues) =>
      create({
        clientId: clientId,
        body: { data: buildContactData(values) },
      }).unwrap(),
    update: (id: string, values: ContactFormValues) =>
      update({
        clientId: clientId,
        id: id,
        body: { data: buildContactData(values, id) },
      }).unwrap(),
    archive: (id: string) =>
      destroy({ clientId: clientId, id: id }).unwrap(),
  };
};

export default useContactMutations;
